import React from 'react';
import useAuth from '../../../hooks/useAuth';
import { NavLink } from 'react-router-dom';

// * IMPORTS HELPERS
// import { Global } from '../../../helpers/Global';

// * IMPORT MEDIA CUSTOM
import logoSpingo from '../../../assets/img/general/spingo-logo.png';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import WebhookOutlinedIcon from '@mui/icons-material/WebhookOutlined';
import SourceOutlinedIcon from '@mui/icons-material/SourceOutlined';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';

const pages = [];
const settings = [];

export const Header = () => {

    // * HOOKS
    const { auth } = useAuth();

    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    // * GOOGLE
    // const clientIDGoogle = '534112475501-qrn3hav796olnstqrqrtnp44lb3867ff.apps.googleusercontent.com';

    const propsIcons = { color: 'gray', marginRight: '5px' };

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    return (
        <AppBar position="static" sx={{ bgcolor: '#3340e3' }}>
            <Container maxWidth="xl">
                <Toolbar disableGutters>

                    <Box
                        component="img"
                        sx={{
                            display: { xs: 'none', md: 'flex' },
                            maxWidth: "12%", maxHeight: "calc(100vh - 64px)",
                            mr: 0
                        }}
                        alt="Spingo Logo General"
                        src={logoSpingo}
                    />

                    <Typography
                        variant="h6"
                        noWrap
                        component="a"
                        href="/"
                        sx={{
                            mr: 2,
                            display: { xs: 'none', md: 'flex' },
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.3rem',
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                    </Typography>

                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            <MenuItem key={'item-menu-mobile-solicitud'}>
                                <Typography component={'span'} textAlign="center">
                                    <NavLink to="/onboarding" className='item-private-layout'>
                                        <Typography textAlign="center">Solicitud</Typography>
                                    </NavLink>
                                </Typography>
                            </MenuItem>

                            {pages.map((page) => (
                                <MenuItem key={page} onClick={handleCloseNavMenu}>
                                    <Typography textAlign="center">{page}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>

                    <Box
                        component="img"
                        sx={{
                            display: { xs: 'flex', md: 'none' },
                            mr: 1
                        }}
                        alt="Spingo Logo Mobile"
                        src={logoSpingo}
                    />

                    <Typography
                        variant="h5"
                        noWrap
                        component="a"
                        href=""
                        sx={{
                            mr: 2,
                            display: { xs: 'flex', md: 'none' },
                            flexGrow: 1,
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.3rem',
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                    </Typography>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        <Button key={'onboarding-item-menu'} sx={{ my: 2, color: 'white', display: 'block' }}>
                            <NavLink to="/onboarding" className='text-decoration-none' >
                                <Typography textAlign="center">Solicitud</Typography>
                            </NavLink>
                        </Button>
                        {pages.map((page) => (
                            <Button
                                key={page}
                                onClick={handleCloseNavMenu}
                                sx={{ my: 2, color: 'white', display: 'block' }}
                            >
                                {page}
                            </Button>
                        ))}
                    </Box>

                    <Box sx={{ flexGrow: 0 }}>
                        <Tooltip title="Abrir configuraxión">
                            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                <Avatar alt="Remy Sharp" src={auth.imageUrlGoogle != null ? auth.imageUrlGoogle : 'https://cdn-icons-png.flaticon.com/512/149/149071.png'} />
                            </IconButton>
                        </Tooltip>
                        <Menu
                            sx={{ mt: '45px' }}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >
                            <MenuItem>
                                <AccountCircleOutlinedIcon sx={propsIcons} /><Typography textAlign="center">{auth.name}</Typography>
                            </MenuItem>

                            {/* Si es admin podra acceder al backoffice */}
                            {
                                auth.role === 'admin' &&
                                <div>
                                    {/* <MenuItem>
                                        <WebhookOutlinedIcon sx={propsIcons} />
                                        <NavLink to="/hubspot" className='item-private-layout'>
                                            <Typography textAlign="center">HubSpot</Typography>
                                        </NavLink>
                                    </MenuItem>
                                    <MenuItem>
                                        <SourceOutlinedIcon sx={propsIcons} />
                                        <NavLink to="/backoffice" className='item-private-layout'>
                                            <Typography textAlign="center">Backoffice</Typography>
                                        </NavLink>
                                    </MenuItem> */}
                                </div>
                            }

                            {settings.map((setting) => (
                                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                                    <Typography textAlign="center">{setting}</Typography>
                                </MenuItem>
                            ))}
                            <MenuItem>
                                <LoginOutlinedIcon sx={propsIcons} />
                                <NavLink to="/onboarding/logout" className='item-private-layout'>
                                    <Typography textAlign="center">Cerrar Sesión</Typography>
                                </NavLink>
                            </MenuItem>
                        </Menu>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
}
